const TEMPLATES_URI = 'templates';
const SUBMISSIONS_URI = 'submissions';
const ENDORSEMENTS_URI = 'endorsements';

export const getCurrentDocumentApiUrl = (templateId?: string, submissionId?: string, endorsementId?: string) => {
  switch (true) {
    case !!templateId:
      return [TEMPLATES_URI, templateId].join('/');
    case !!submissionId && !endorsementId:
      return [SUBMISSIONS_URI, submissionId].join('/');
    case !!submissionId && !!endorsementId:
      return [SUBMISSIONS_URI, submissionId, ENDORSEMENTS_URI, endorsementId].join('/');
    default:
      return undefined;
  }
};
